import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux'; // Or useContext if you're using React Context
import CurrentClubIndicator from '../../containers/CurrentClubIndicator';
import AppDrawer from '../AppDrawer';
import DraggableNotes from '../../containers/DraggableNotes';
import AuthModal from '../AuthModal';
import { Box } from '@mui/material';
import './styles.css';

const ProtectedRoute = (props:any) => {
    const { element } = props;
    const token:any = useSelector((state:any) => state.common.token);
    const [isOpen, setIsOpen] = React.useState(false);
    if (!token) {
        return <Navigate to="/login" />;
    }

    return (
        <>
            <CurrentClubIndicator />
            <Box className="drawerWrapper">
                <AppDrawer isDrawerOpen={isOpen} setDrawerIsOpen={() => setIsOpen(!isOpen)} />
            </Box>
            {element}
            <DraggableNotes />
            <AuthModal />
        </>
    );
};

export default ProtectedRoute;
